import { ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import zhCN from 'antd/locale/zh_CN';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './auth/AuthContext';
import RequireAuth from './auth/RequireAuth';
import Layout from './components/Layout';
import ContentManagement from './pages/ContentManagement';
import AccountManagement from './pages/AccountManagement';
import TimedPublish from './pages/TimedPublish';
import ContentProduce from './pages/ContentProduce';
import Login from './pages/Login';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={(
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              )}
            >
              <Route index element={<Navigate to="/content" replace />} />
              <Route path="produce" element={<ContentProduce />} />
              <Route path="content" element={<ContentManagement />} />
              <Route path="timedPublish" element={<TimedPublish />} />
              <Route path="users" element={<AccountManagement />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
